import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEY_ROOTS } from 'variables';
import { QueryOptionsConfig } from 'api/hooks';
import { getDiscoveryShareDate } from './discoveryShareDate';

export const useGetDiscoveryShareDate = (
  profileId: string,
  config: QueryOptionsConfig<string | null> = {},
): UseQueryResult<string | null, Error> =>
  useQuery<string | null, Error>({
    queryKey: [QUERY_KEY_ROOTS.DISCOVERY_SHARE_DATE, profileId],
    queryFn: async () => getDiscoveryShareDate(profileId),
    ...config,
  });
